import { render, staticRenderFns } from "./Sut.vue?vue&type=template&id=3bede476&"
import script from "./Sut.vue?vue&type=script&lang=js&"
export * from "./Sut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports